import { useRef } from 'react';

import { Box, BoxProps } from '@chakra-ui/react';

import { useScrollToOnError } from 'common/hooks/ScrollToOnError';

interface ScrollToOnErrorProps {
  name: string;
}

export default function ScrollToOnError({ name, children, ...boxProps }: ScrollToOnErrorProps & BoxProps) {
  const targetRef = useRef<HTMLDivElement>(null);
  useScrollToOnError(targetRef, name);

  return (
    <Box ref={targetRef} {...boxProps}>
      {children}
    </Box>
  );
}
